// extracted by mini-css-extract-plugin
export default {"body":"body-g2qWb","subHeader":"subHeader-PCMWh","name":"name-GmiGU","description":"description-bYrRM","divider":"divider-NnwdC","previewFormContainer":"previewFormContainer-YryHV"};